export default class Config {
  apiUrls = {
    production: "",
    preproduction: "",
    localdev: "",
  };

  storeUrls = {
    production: "",
    preproduction: "",
    localdev: "",
  };

  mainUrls = {
    production: "",
    preproduction: "",
    localdev: "",
  };

  constructor(
    apiUrls = { production, preproduction, localdev },
    storeUrls = { production, preproduction, localdev },
    mainUrls = { production, preproduction, localdev }
  ) {
    this.apiUrls = apiUrls;
    this.storeUrls = storeUrls;
    this.mainUrls = mainUrls;
  }

  ARTICLE_MODES = {
    REGULAR: 1,
    JOURNAL: 2,
    SERVICE: 3,
    BLOG: 4,
    GUIDE: 5,
    REVIEW: 6,
  };

  getApiUrl = () => this.apiUrls[process.env.NODE_ENV];
  getStoreUrl = () => this.storeUrls[process.env.NODE_ENV];
  getMainUrl = () => this.mainUrls[process.env.NODE_ENV];

  get loadItemsOnEveryRouteChange() {
    throw new Error("Not implemented");
  }

  get automodalsConfig() {
    throw new Error("Not implemented");
    // use below config as a guideline

    return {
      showModelModerationModals: false,
    };
  }

  get menuConfig() {
    throw new Error("Not implemented");
    // use below config as a guideline

    return {
      canSelectProject: false,
      canCreateConsultation: true,
    };
  }

  get accountConfig() {
    throw new Error("Not implemented");
    // use below config as a guideline

    return {
      showTarifficationLink: true,
      isUserAuthor: false,
    };
  }

  get courseConfig() {
    throw new Error("Not implemented");
    // use below config as a guideline

    return {
      handleCourseItemSellSettingsRouting: (courseEditPageInstance) => {},
      showGroupManagementTab: true,
      subheaderBackButton: {
        route: {
          path: "/courses",
        },
        caption: "к курсам",
      },
      showKeyAdvantagesInput: false,
      logoCaption: "Логотип",
      showOwnerLink: false,
    };
  }

  get itemConfig() {
    throw new Error("Not implemented");
    // use below config as a guideline

    return {
      showModerationStatus: false,
    };
  }

  get shopSettingsConfig() {
    throw new Error("Not implemented");
    // use below config as a guideline

    return {
      subheaderTitle: "Настройки",
      shopNameInputCaption: "магазина",
      showDescriptionTextarea: false,
      showEmailSenderInput: true,
      showLinks: false,
      showAccessCard: true,
      showPartnershipSettings: true,
      showKursorTariffcation: false,
      showUserNotifySettings: true,
      showAuthorPageUrl: false,
      showStateSwitcher: false,
      showCatalogCard: true,
    };
  }

  get profileConfig() {
    throw new Error("Not implemented");
    // use below config as a guideline

    return {
      showUserNotifySettings: false,
      showDescriptionTextarea: true,
      telegramBot: 'edeone_user_bot'
    }
  }

  get metrikaConfig() {
    throw new Error("Not implemented");
  }

  get footerLinks() {
    throw new Error("Not implemented");
  }

  get supportLink() {
    throw new Error("Not implemented");
  }

  get helpLinks() {
    throw new Error("Not implemented");
    // use below config as a guideline

    return {
      main: 'https://edeone.com/help',
      item: 'https://edeone.com/help/product',
      promotion: 'https://edeone.com/help/promotion',
      order: 'https://edeone.com/help/orders',
      client: 'https://edeone.com/help/clients',
      statistics: 'https://edeone.com/help/statistic',
      projectSettings: 'https://edeone.com/help/progect-settings',
      integration: 'https://edeone.com/help/integration',
      course: 'https://edeone.com/help/course',
      partnership: 'https://edeone.com/help/partnership',
      coauthorship: 'https://edeone.com/help/for-authors',
      referral: 'https://edeone.com/help/referral-program',
      profile: 'https://edeone.com/help/profile',
      finance: 'https://edeone.com/help/finance',
      tariff: 'https://edeone.com/help/services',
    }
  }
}
